export const DefaultLayout = `{"id":-1,"itemType":1,"styleObj":{"fill":{"fillIds":["b469ca57-a59d-48ae-847f-592fc99a7b99"],"fillId": null,"repeatSwitch": false,"bgImageSize": false,"stretch": false,"bgImagePosition": "left"}},"item":{"id":"HTML_DIV","properties":[{"name":"style","selectedType":2,"value":""}]},"children":[],"screenDesign":"[Circular ~]"}`;

export const MasterLayout = `{ "id": -1, "itemType": 1, "styleObj": { "fill": { "fillIds": ["b469ca57-a59d-48ae-847f-592fc99a7b99"], "fillId": null, "repeatSwitch": false, "bgImageSize": false, "stretch": false, "bgImagePosition": "left" } }, "item": { "id": "HTML_DIV", "properties": [{ "name": "style", "selectedType": 2, "value": "" }] }, "children": [], "screenDesign": "[Circular ~]" },
{
  "id": -10,
  "item": {
    "id": "6fe598c9-9601-4fc6-46d2-08db564939a6",
    "properties": [
      { "name": "style", "selectedType": 2, "symbol": { "category": 4, "fixedValue": "{}", "label": "Value", "description": "Fixed Value" } },
      { "name": "className", "selectedType": 1, "symbol": {} }
    ],
    "name": "LayoutHeader"
  },
  "children": [
    {
        "id": 42808,
        "item": {
          "id": "31218097-b7bc-413c-8334-8184e6e4594b",
          "properties": [
            {
              "name": "style",
              "selectedType": 2,
              "symbol": {
                "category": 4,
                "fixedValue": "{padding: '5px'}",
                "label": "Value",
                "description": "Fixed Value"
              }
            },
            {
              "name": "align",
              "selectedType": 1,
              "symbol": {
                "category": 4,
                "fixedValue": "top",
                "label": "align",
                "description": "align"
              }
            },
            {
              "name": "justify",
              "selectedType": 1,
              "symbol": {
                "category": 4,
                "fixedValue": "start",
                "label": "justify",
                "description": "justify"
              }
            },
            {
              "name": "horizontalGutter",
              "selectedType": 9,
              "symbol": {
                "category": 4,
                "fixedValue": "0",
                "label": "Value",
                "description": "Fixed Value"
              }
            },
            {
              "name": "verticalGutter",
              "selectedType": 9,
              "symbol": {
                "category": 4,
                "fixedValue": "0",
                "label": "Value",
                "description": "Fixed Value"
              }
            },
            {
              "name": "onClick",
              "selectedType": 3,
              "symbol": {}
            },
            {
              "name": "className",
              "selectedType": 1,
              "symbol": {}
            }
          ],
          "name": "Row"
        },
        "children": [
          {
            "id": 253202,
            "item": {
              "id": "64a2eacc-e2e5-4ee8-a1f3-94e51a363b02",
              "properties": [
                {
                  "name": "xs",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "sm",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "md",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "lg",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "xl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xl",
                    "description": "xl"
                  }
                },
                {
                  "name": "xxl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xxl",
                    "description": "xxl"
                  }
                },
                {
                  "name": "style",
                  "selectedType": 2,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "style",
                    "description": "style"
                  }
                },
                {
                  "name": "flex",
                  "selectedType": 1,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "flex",
                    "description": "flex"
                  }
                },
                {
                  "name": "offset",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "offset",
                    "description": "offset"
                  }
                },
                {
                  "name": "order",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "order",
                    "description": "order"
                  }
                },
                {
                  "name": "pull",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "pull",
                    "description": "pull"
                  }
                },
                {
                  "name": "push",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "push",
                    "description": "push"
                  }
                },
                {
                  "name": "span",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "span",
                    "description": "span"
                  }
                },
                {
                  "name": "onClick",
                  "selectedType": 3,
                  "symbol": {}
                },
                {
                  "name": "className",
                  "selectedType": 1,
                  "symbol": {}
                }
              ],
              "name": "Col"
            },
            "children": [],
            "parentId": 42808,
            "friendlyName": "Col1_0",
            "styleObj": {
              "text": {
                "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
                "typoIds": [
                  "",
                  "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
                ]
              },
              "border": {
                "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
                "borderIds": [
                  "",
                  "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
                ]
              },
              "position": {
                "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
                "positionIds": [
                  "",
                  "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
                ]
              },
              "shadow": {
                "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
                "shadowIds": [
                  "",
                  "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
                ]
              },
              "fill": {
                "fillId": "|undefined",
                "fillIds": [
                  "",
                  null
                ]
              }
            }
          },
          {
            "id": 553847,
            "item": {
              "id": "64a2eacc-e2e5-4ee8-a1f3-94e51a363b02",
              "properties": [
                {
                  "name": "xs",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "sm",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "md",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "lg",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "xl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xl",
                    "description": "xl"
                  }
                },
                {
                  "name": "xxl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xxl",
                    "description": "xxl"
                  }
                },
                {
                  "name": "style",
                  "selectedType": 2,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "style",
                    "description": "style"
                  }
                },
                {
                  "name": "flex",
                  "selectedType": 1,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "flex",
                    "description": "flex"
                  }
                },
                {
                  "name": "offset",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "offset",
                    "description": "offset"
                  }
                },
                {
                  "name": "order",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "order",
                    "description": "order"
                  }
                },
                {
                  "name": "pull",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "pull",
                    "description": "pull"
                  }
                },
                {
                  "name": "push",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "push",
                    "description": "push"
                  }
                },
                {
                  "name": "span",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "span",
                    "description": "span"
                  }
                },
                {
                  "name": "onClick",
                  "selectedType": 3,
                  "symbol": {}
                },
                {
                  "name": "className",
                  "selectedType": 1,
                  "symbol": {}
                }
              ],
              "name": "Col"
            },
            "children": [],
            "parentId": 42808,
            "friendlyName": "Col1_1",
            "styleObj": {
              "text": {
                "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
                "typoIds": [
                  "",
                  "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
                ]
              },
              "border": {
                "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
                "borderIds": [
                  "",
                  "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
                ]
              },
              "position": {
                "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
                "positionIds": [
                  "",
                  "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
                ]
              },
              "shadow": {
                "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
                "shadowIds": [
                  "",
                  "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
                ]
              },
              "fill": {
                "fillId": "|undefined",
                "fillIds": [
                  "",
                  null
                ]
              }
            }
          },
          {
            "id": 876915,
            "item": {
              "id": "64a2eacc-e2e5-4ee8-a1f3-94e51a363b02",
              "properties": [
                {
                  "name": "xs",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "sm",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "md",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "lg",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "xl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xl",
                    "description": "xl"
                  }
                },
                {
                  "name": "xxl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xxl",
                    "description": "xxl"
                  }
                },
                {
                  "name": "style",
                  "selectedType": 2,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "style",
                    "description": "style"
                  }
                },
                {
                  "name": "flex",
                  "selectedType": 1,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "flex",
                    "description": "flex"
                  }
                },
                {
                  "name": "offset",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "offset",
                    "description": "offset"
                  }
                },
                {
                  "name": "order",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "order",
                    "description": "order"
                  }
                },
                {
                  "name": "pull",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "pull",
                    "description": "pull"
                  }
                },
                {
                  "name": "push",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "push",
                    "description": "push"
                  }
                },
                {
                  "name": "span",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "span",
                    "description": "span"
                  }
                },
                {
                  "name": "onClick",
                  "selectedType": 3,
                  "symbol": {}
                },
                {
                  "name": "className",
                  "selectedType": 1,
                  "symbol": {}
                }
              ],
              "name": "Col"
            },
            "children": [],
            "parentId": 42808,
            "friendlyName": "Col1_2",
            "styleObj": {
              "text": {
                "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
                "typoIds": [
                  "",
                  "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
                ]
              },
              "border": {
                "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
                "borderIds": [
                  "",
                  "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
                ]
              },
              "position": {
                "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
                "positionIds": [
                  "",
                  "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
                ]
              },
              "shadow": {
                "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
                "shadowIds": [
                  "",
                  "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
                ]
              },
              "fill": {
                "fillId": "|undefined",
                "fillIds": [
                  "",
                  null
                ]
              }
            }
          }
        ],
        "parentId": -10,
        "friendlyName": "Row1",
        "styleObj": {
          "text": {
            "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
            "typoIds": [
              "",
              "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
            ]
          },
          "border": {
            "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
            "borderIds": [
              "",
              "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
            ]
          },
          "position": {
            "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
            "positionIds": [
              "",
              "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
            ]
          },
          "shadow": {
            "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
            "shadowIds": [
              "",
              "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
            ]
          },
          "fill": {
            "fillId": "|undefined",
            "fillIds": [
              "",
              null
            ]
          }
        }
      }
  ],
  "friendlyName": "LayoutHeader",
  "styleObj": { "text": { "typoId": "|BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7", "typoIds": ["", "BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7"] }, "border": { "borderId": "|F18FDAFF-2B3A-4D13-8736-F9810122D2D7", "borderIds": ["", "F18FDAFF-2B3A-4D13-8736-F9810122D2D7"] }, "position": { "positionId": "|5E4C4E2C-7FDF-1246-0674-209AA4365F66", "positionIds": ["", "5E4C4E2C-7FDF-1246-0674-209AA4365F66"], "minHeight": 60 }, "shadow": { "shadowId": "|D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5", "shadowIds": ["", "D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5"] }, "fill": { "fillId": "|DA58255A-AD5C-8E21-8AAD-3A83F2DFA358", "fillIds": ["", "DA58255A-AD5C-8E21-8AAD-3A83F2DFA358"] } }
},
{
  "id": -11,
  "item": {
    "id": "e6735a0d-3668-4b55-46d3-08db564939a6",
    "properties": [
      { "name": "style", "selectedType": 2, "symbol": { "category": 4, "fixedValue": "{}", "label": "Value", "description": "Fixed Value" } },
      { "name": "className", "selectedType": 1, "symbol": {} }
    ],
    "name": "LayoutFooter"
  },
  "children": [{
        "id": 82256,
        "item": {
          "id": "31218097-b7bc-413c-8334-8184e6e4594b",
          "properties": [
            {
              "name": "style",
              "selectedType": 2,
              "symbol": {
                "category": 4,
                "fixedValue": "{padding: '5px'}",
                "label": "Value",
                "description": "Fixed Value"
              }
            },
            {
              "name": "align",
              "selectedType": 1,
              "symbol": {
                "category": 4,
                "fixedValue": "top",
                "label": "align",
                "description": "align"
              }
            },
            {
              "name": "justify",
              "selectedType": 1,
              "symbol": {
                "category": 4,
                "fixedValue": "start",
                "label": "justify",
                "description": "justify"
              }
            },
            {
              "name": "horizontalGutter",
              "selectedType": 9,
              "symbol": {
                "category": 4,
                "fixedValue": "0",
                "label": "Value",
                "description": "Fixed Value"
              }
            },
            {
              "name": "verticalGutter",
              "selectedType": 9,
              "symbol": {
                "category": 4,
                "fixedValue": "0",
                "label": "Value",
                "description": "Fixed Value"
              }
            },
            {
              "name": "onClick",
              "selectedType": 3,
              "symbol": {}
            },
            {
              "name": "className",
              "selectedType": 1,
              "symbol": {}
            }
          ],
          "name": "Row"
        },
        "children": [
          {
            "id": 762118,
            "item": {
              "id": "64a2eacc-e2e5-4ee8-a1f3-94e51a363b02",
              "properties": [
                {
                  "name": "xs",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "sm",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "md",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "lg",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "xl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xl",
                    "description": "xl"
                  }
                },
                {
                  "name": "xxl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xxl",
                    "description": "xxl"
                  }
                },
                {
                  "name": "style",
                  "selectedType": 2,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "style",
                    "description": "style"
                  }
                },
                {
                  "name": "flex",
                  "selectedType": 1,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "flex",
                    "description": "flex"
                  }
                },
                {
                  "name": "offset",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "offset",
                    "description": "offset"
                  }
                },
                {
                  "name": "order",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "order",
                    "description": "order"
                  }
                },
                {
                  "name": "pull",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "pull",
                    "description": "pull"
                  }
                },
                {
                  "name": "push",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "push",
                    "description": "push"
                  }
                },
                {
                  "name": "span",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "span",
                    "description": "span"
                  }
                },
                {
                  "name": "onClick",
                  "selectedType": 3,
                  "symbol": {}
                },
                {
                  "name": "className",
                  "selectedType": 1,
                  "symbol": {}
                }
              ],
              "name": "Col"
            },
            "children": [],
            "parentId": 82256,
            "friendlyName": "Col4_0",
            "styleObj": {
              "text": {
                "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
                "typoIds": [
                  "",
                  "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
                ]
              },
              "border": {
                "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
                "borderIds": [
                  "",
                  "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
                ]
              },
              "position": {
                "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
                "positionIds": [
                  "",
                  "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
                ]
              },
              "shadow": {
                "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
                "shadowIds": [
                  "",
                  "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
                ]
              },
              "fill": {
                "fillId": "|undefined",
                "fillIds": [
                  "",
                  null
                ]
              }
            }
          },
          {
            "id": 926225,
            "item": {
              "id": "64a2eacc-e2e5-4ee8-a1f3-94e51a363b02",
              "properties": [
                {
                  "name": "xs",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "sm",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "md",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "lg",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "xl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xl",
                    "description": "xl"
                  }
                },
                {
                  "name": "xxl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xxl",
                    "description": "xxl"
                  }
                },
                {
                  "name": "style",
                  "selectedType": 2,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "style",
                    "description": "style"
                  }
                },
                {
                  "name": "flex",
                  "selectedType": 1,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "flex",
                    "description": "flex"
                  }
                },
                {
                  "name": "offset",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "offset",
                    "description": "offset"
                  }
                },
                {
                  "name": "order",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "order",
                    "description": "order"
                  }
                },
                {
                  "name": "pull",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "pull",
                    "description": "pull"
                  }
                },
                {
                  "name": "push",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "push",
                    "description": "push"
                  }
                },
                {
                  "name": "span",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "span",
                    "description": "span"
                  }
                },
                {
                  "name": "onClick",
                  "selectedType": 3,
                  "symbol": {}
                },
                {
                  "name": "className",
                  "selectedType": 1,
                  "symbol": {}
                }
              ],
              "name": "Col"
            },
            "children": [],
            "parentId": 82256,
            "friendlyName": "Col4_1",
            "styleObj": {
              "text": {
                "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
                "typoIds": [
                  "",
                  "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
                ]
              },
              "border": {
                "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
                "borderIds": [
                  "",
                  "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
                ]
              },
              "position": {
                "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
                "positionIds": [
                  "",
                  "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
                ]
              },
              "shadow": {
                "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
                "shadowIds": [
                  "",
                  "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
                ]
              },
              "fill": {
                "fillId": "|undefined",
                "fillIds": [
                  "",
                  null
                ]
              }
            }
          },
          {
            "id": 181557,
            "item": {
              "id": "64a2eacc-e2e5-4ee8-a1f3-94e51a363b02",
              "properties": [
                {
                  "name": "xs",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "sm",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "md",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "lg",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "Value",
                    "description": "Fixed Value"
                  }
                },
                {
                  "name": "xl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xl",
                    "description": "xl"
                  }
                },
                {
                  "name": "xxl",
                  "selectedType": 4,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "8",
                    "label": "xxl",
                    "description": "xxl"
                  }
                },
                {
                  "name": "style",
                  "selectedType": 2,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "style",
                    "description": "style"
                  }
                },
                {
                  "name": "flex",
                  "selectedType": 1,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "flex",
                    "description": "flex"
                  }
                },
                {
                  "name": "offset",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "offset",
                    "description": "offset"
                  }
                },
                {
                  "name": "order",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "order",
                    "description": "order"
                  }
                },
                {
                  "name": "pull",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "pull",
                    "description": "pull"
                  }
                },
                {
                  "name": "push",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "0",
                    "label": "push",
                    "description": "push"
                  }
                },
                {
                  "name": "span",
                  "selectedType": 9,
                  "symbol": {
                    "category": 4,
                    "fixedValue": "",
                    "label": "span",
                    "description": "span"
                  }
                },
                {
                  "name": "onClick",
                  "selectedType": 3,
                  "symbol": {}
                },
                {
                  "name": "className",
                  "selectedType": 1,
                  "symbol": {}
                }
              ],
              "name": "Col"
            },
            "children": [],
            "parentId": 82256,
            "friendlyName": "Col4_2",
            "styleObj": {
              "text": {
                "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
                "typoIds": [
                  "",
                  "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
                ]
              },
              "border": {
                "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
                "borderIds": [
                  "",
                  "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
                ]
              },
              "position": {
                "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
                "positionIds": [
                  "",
                  "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
                ]
              },
              "shadow": {
                "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
                "shadowIds": [
                  "",
                  "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
                ]
              },
              "fill": {
                "fillId": "|undefined",
                "fillIds": [
                  "",
                  null
                ]
              }
            }
          }
        ],
        "parentId": -11,
        "friendlyName": "Row2",
        "styleObj": {
          "text": {
            "typoId": "|bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7",
            "typoIds": [
              "",
              "bcaa7c5f-fcc4-439e-bf8d-00ca4ba9d0d7"
            ]
          },
          "border": {
            "borderId": "|f18fdaff-2b3a-4d13-8736-f9810122d2d7",
            "borderIds": [
              "",
              "f18fdaff-2b3a-4d13-8736-f9810122d2d7"
            ]
          },
          "position": {
            "positionId": "|7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f",
            "positionIds": [
              "",
              "7e96f5a6-91ca-4e22-83a1-0aa58e9e5f1f"
            ]
          },
          "shadow": {
            "shadowId": "|d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5",
            "shadowIds": [
              "",
              "d49a2c47-bca8-fac2-b0e6-49a88a1d8cb5"
            ]
          },
          "fill": {
            "fillId": "|undefined",
            "fillIds": [
              "",
              null
            ]
          }
        }
      }],
  "friendlyName": "LayoutFooter",
  "styleObj": { "text": { "typoId": "|BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7", "typoIds": ["", "BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7"] }, "border": { "borderId": "|F18FDAFF-2B3A-4D13-8736-F9810122D2D7", "borderIds": ["", "F18FDAFF-2B3A-4D13-8736-F9810122D2D7"] }, "position": { "positionId": "|5E4C4E2C-7FDF-1246-0674-209AA4365F66", "positionIds": ["", "5E4C4E2C-7FDF-1246-0674-209AA4365F66"], "minHeight": 60 }, "shadow": { "shadowId": "|D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5", "shadowIds": ["", "D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5"] }, "fill": { "fillId": "|DA58255A-AD5C-8E21-8AAD-3A83F2DFA358", "fillIds": ["", "DA58255A-AD5C-8E21-8AAD-3A83F2DFA358"] } }
},
{
  "id": -12,
  "item": {
    "id": "a979797e-6e11-44e6-bae6-73a3c014b711",
    "properties": [
      { "name": "style", "selectedType": 2, "symbol": { "category": 4, "fixedValue": "{}", "label": "Value", "description": "Fixed Value" } },
      { "name": "className", "selectedType": 1, "symbol": {} }
    ],
    "name": "LayoutLeft"
  },
  "children": [],
  "friendlyName": "LayoutLeft",
  "styleObj": { "text": { "typoId": "|BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7", "typoIds": ["", "BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7"] }, "border": { "borderId": "|F18FDAFF-2B3A-4D13-8736-F9810122D2D7", "borderIds": ["", "F18FDAFF-2B3A-4D13-8736-F9810122D2D7"] }, "position": { "positionId": "|5E4C4E2C-7FDF-1246-0674-209AA4365F66", "positionIds": ["", "5E4C4E2C-7FDF-1246-0674-209AA4365F66"], "width": 100 }, "shadow": { "shadowId": "|D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5", "shadowIds": ["", "D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5"] }, "fill": { "fillId": "|DA58255A-AD5C-8E21-8AAD-3A83F2DFA358", "fillIds": ["", "DA58255A-AD5C-8E21-8AAD-3A83F2DFA358"] } }
},
{
  "id": -13,
  "item": {
    "id": "a979797e-6e11-44e6-bae6-73a3c014b712",
    "properties": [
      { "name": "style", "selectedType": 2, "symbol": { "category": 4, "fixedValue": "{}", "label": "Value", "description": "Fixed Value" } },
      {
    "name": "layoutPosition",
    "symbol": {
        "category": 4,
        "fixedValue": "0",
        "label": "Value",
        "description": "Fixed Value"
    },
    "selectedType": 9
},
      { "name": "className", "selectedType": 1, "symbol": {} }
    ],
    "name": "LayoutRight"
  },
  "children": [],
  "friendlyName": "LayoutRight",
  "styleObj": { "text": { "typoId": "|BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7", "typoIds": ["", "BCAA7C5F-FCC4-439E-BF8D-00CA4BA9D0D7"] }, "border": { "borderId": "|F18FDAFF-2B3A-4D13-8736-F9810122D2D7", "borderIds": ["", "F18FDAFF-2B3A-4D13-8736-F9810122D2D7"] }, "position": { "positionId": "|5E4C4E2C-7FDF-1246-0674-209AA4365F66", "positionIds": ["", "5E4C4E2C-7FDF-1246-0674-209AA4365F66"], "width": 100 }, "shadow": { "shadowId": "|D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5", "shadowIds": ["", "D49A2C47-BCA8-FAC2-B0E6-49A88A1D8CB5"] }, "fill": { "fillId": "|DA58255A-AD5C-8E21-8AAD-3A83F2DFA358", "fillIds": ["", "DA58255A-AD5C-8E21-8AAD-3A83F2DFA358"] } }
}`;
